import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from '../QueryKeys';
import { EProductLibraryStatus } from '../../api/getProductLibrarySyncStatus/getProductLibrarySyncStatus';
import { rejectVenueSync } from 'src/api/rejectVenueSync/rejectVenueSync';
import { IVenueLibraryStatus } from '../useVenueLibraryStatus/useVenueLibraryStatus';
import { useUpdateNotification } from 'src/hooks/useUpdateNotification/useUpdateNotification';
import { NotificationType } from 'src/api/getNotifications/getNotifications';

export const useRejectVenueSync = () => {
  const syncQueryKey = [getBrandId(), QueryKeys.venueSyncStatus];
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();
  const { markNotificationRead } = useUpdateNotification();

  const mutation = useMutation({
    mutationFn: async (eventId: string) => rejectVenueSync(eventId),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: syncQueryKey });

      queryClient.setQueryData(syncQueryKey, (old: IVenueLibraryStatus) => ({
        ...old,
        status: EProductLibraryStatus.REJECTED,
      }));
    },
    onError: (error: unknown) => {
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: error instanceof Error ? error.message : 'Failed to reject sync',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.notifications] });

      markNotificationRead((notification) => notification.type === NotificationType.VENUE_SYNC);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: syncQueryKey });
    },
  });

  return {
    rejectSync: mutation.mutate,
  };
};
